const getPossibleResultsFromAnswers = (answerId, index, allQuestions) => {
    const questionWithBonus = allQuestions[index].questions.bonus
    let resultString = allQuestions[index].questions[answerId].results
    if (questionWithBonus === "1") {
        resultString = resultString.concat(`, ${resultString}`)
    }
    return resultString.split(",")
}

const allResultsTally = possibleResultsFromAnswers =>
    possibleResultsFromAnswers.reduce((results, c) => {
        const current = c?.trim()

        if (current in results) {
            results[current]++
        } else {
            results[current] = 1
        }
        return results
    }, {})

const shuffle = array => {
    let currentIndex = array.length
    let temporaryValue = null
    let randomIndex = null

    // While there remain elements to shuffle...
    while (currentIndex !== 0) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex)
        currentIndex -= 1

        // And swap it with the current element.
        temporaryValue = array[currentIndex]
        array[currentIndex] = array[randomIndex]
        array[randomIndex] = temporaryValue
    }

    return array
}

const sortAllResults = (allResults, talliedResults) => {
    const addScoretoAllResults = allResults
        .map(el => {
            const resultScore = { score: talliedResults[el.results.result] }
            return { ...el, ...resultScore }
        })
        .filter(el => el.score)

    const sortScoredResults = addScoretoAllResults.sort((a, b) => {
        return b.score - a.score
    })

    return sortScoredResults
}

const determineWinner = sortedResults => {
    const highestScore = sortedResults[0].score

    const possibleTiedWinners = sortedResults.filter(el => {
        return el.score === highestScore
    })

    if (possibleTiedWinners.length === 1) {
        return sortedResults
    }

    const shuffleTiedWinners = shuffle(possibleTiedWinners)

    const removeTiedWinners = sortedResults.slice(shuffleTiedWinners.length)
    const tiedWinnerResults = shuffleTiedWinners.concat(removeTiedWinners)

    return tiedWinnerResults
}

export const getResult = (data, answers) => {
    const allQuestions = data.questions.nodes
    const allResults = data.results.nodes

    const possibleResultsFromAnswers = allQuestions
        .flatMap((question, i) => {
            if (answers[question.questions.question_id]) {
                return getPossibleResultsFromAnswers(
                    answers[question.questions.question_id],
                    i,
                    allQuestions
                )
            }
        })
        .filter(el => el)

    const talliedResults = allResultsTally(possibleResultsFromAnswers)

    const sortedResults = sortAllResults(allResults, talliedResults)

    return determineWinner(sortedResults)
}
